import axios from 'axios';
import { auth } from '@/lib/firebase';
import { createAuthHeaders } from '../api-client';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export interface CheckChangesResponse {
  hasChanges: boolean;
  changedFiles: string[];
  filesCount: number;
  notGitRepo?: boolean;
}

export interface Commit {
  id: string;
  commitSha: string;
  message: string;
  branch: string;
  createdAt: string;
  commitDate: string;
  createdBy?: string;
  fileCount?: number;
  totalSize?: number;
  status: 'creating' | 'uploaded' | 'failed';
  metadata?: {
    changedFiles?: number;
    changedSize?: number;
    [key: string]: unknown;
  };
}

export const commitsApi = {
  /**
   * Check for uncommitted changes in the dev container
   * Used before publish to prompt user to commit
   */
  async checkForChanges(projectId: string): Promise<CheckChangesResponse> {
    const token = await auth.getIdToken();
    const response = await axios.get<CheckChangesResponse>(
      `${API_URL}/api/projects/${projectId}/commits/check-changes`,
      { headers: createAuthHeaders(token!) },
    );
    return response.data;
  },

  /**
   * Create a new commit
   */
  async createCommit(
    projectId: string,
    message: string,
    branch?: string,
    metadata?: Record<string, unknown>,
  ): Promise<Commit> {
    const token = await auth.getIdToken();
    const response = await axios.post<Commit>(
      `${API_URL}/api/projects/${projectId}/commits`,
      { message, branch, metadata },
      { headers: createAuthHeaders(token!) },
    );
    return response.data;
  },

  /**
   * List commits for a project
   */
  async listCommits(projectId: string, limit = 50): Promise<Commit[]> {
    const token = await auth.getIdToken();
    const response = await axios.get<Commit[]>(
      `${API_URL}/api/projects/${projectId}/commits`,
      { params: { limit }, headers: createAuthHeaders(token!) },
    );
    return response.data;
  },
};
